import axios from 'axios';
import AxiosBase from '@/auth/axiosBase';
const baseUrl = process.env.VUE_APP_BACKEND_URL;
export default class ImpersonateIslemService extends AxiosBase {
    constructor() {
        super();
    }



    async GetAllPersonelList() {
        let result = {};
        const url = `${baseUrl}/api/Identity/Impersonate/GetAllPersonelList`;
        await axios.get(url)
            .then((response) => {
                result = response;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }


    async GetAllOgrenciList() {
        let result = {};
        const url = `${baseUrl}/api/Identity/Impersonate/GetAllOgrenciList`;
        await axios.get(url)
            .then((response) => {
                result = response;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }
    async GetAllMezunOgrenciList() {
        let result = {};
        const url = `${baseUrl}/api/Identity/Impersonate/GetAllMezunOgrenciList`;
        await axios.get(url)
            .then((response) => {
                result = response;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }
    async GetMezunOgrenciById(ogrNo) {
        let result = {};
        const url = `${baseUrl}/api/Identity/Impersonate/GetMezunOgrenciById?ogrNo=` + ogrNo;
        await axios.get(url)
            .then((response) => {
                result = response;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }
    async login(loginModel) {
        let processResult = 0; // login fail
        let url = `${baseUrl}/api/Identity/Impersonate/Login`;
        const requestBody = JSON.stringify({
            //ZKimlikId: loginModel.ZKimlikId,
            ImpersonateId: loginModel.ImpersonateId,
            Type: loginModel.Type


        });
        await axios.post(url, requestBody)
            .then((response) => {
                processResult = response;

            }).catch((error) => {
                console.log(error);
            });
        return processResult;
    }
    async logout() {

        let result = {};
        const url = `${baseUrl}/api/Identity/Impersonate/Logout`;
        await axios.post(url)
            .then((response) => {
                result = response;
            }).catch((error) => {

                console.log(error);
            });
        return result;
    }
}